"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiListItem = void 0;
var palette_1 = require("../../../theme/global/palette");
var typography_1 = require("../../../theme/global/typography");
exports.MuiListItem = {
    root: __assign({}, typography_1.typography.body2),
    button: {
        '&$focusVisible, &:hover': {
            backgroundColor: palette_1.palette.primary.light,
            color: palette_1.palette.common.white,
        },
        '&$selected': {
            backgroundColor: palette_1.palette.common.white,
            color: palette_1.palette.common.black,
            '&$focusVisible, &:hover': {
                backgroundColor: palette_1.palette.primary.light,
                color: palette_1.palette.common.white,
            },
        },
    },
};
